import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../variables/StripeConfig";
import TimeStamp from "react-timestamp";
import {
  egeeTouchPlans,
  deploymentEnvironment,
  monthNames,
  customLog,
  timestampToDate,
  planToNumber,
} from "../../variables/Variables";
import { cancelSub, showConfirmAlert } from "./SubscriptionManagementHelper";
import ChangeCardElement from "./ChangeCardElement";

import LocalizedStrings from "react-localization";
import { sortedUniq } from "lodash";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    cancelPlanButton: "Cancel Plan",
    changePlanButton: "Change Plan",
    changePaymentButton: "Change Payment Method",
    tableHeaderMax: "Max limit",
    tableHeaderCurrent: "Current",
    titlePlan: "Current Plan",
    titlePayment: "Payment Method",
    titleDetails: "Plan details",
    headerBilling: "Billing",
    subheaderPlan: "Add/Manage up to",
    subheaderPayment: "Card information",
    detailPadlock: "Smart Padlocks",
    detailUsers: "User Accounts",
    detailNFC: "NFC Counts",
    detailApproval: "Layer of Multi Approval",
    detailCardNumber: "Card number",
    detailCardExpiry: "Expiry",
    renewDescription: "Your plan renews on ",
    trialEndDescription1: "Your ",
    trialEndDescription2: "trial ends",
    trialEndDescription3: " on ",
    trialEndDescription4: "",
    trialNotice:
      "To continue using the system after your trial ends, please upgrade to a paid plan.",
    trialWebOnlyNote:
      "This only affects the web dashboard — the eGeeTouch mobile app remains usable as usual after your trial ends.",
    planTypeMonth: "/month",
    planTypeYear: "/year",
  },
  ja: {
    cancelPlanButton: "プランをキャンセル",
    changePlanButton: "プラン変更",
    changePaymentButton: "お支払登録内容変更",
    tableHeaderMax: "最大",
    tableHeaderCurrent: "現在",
    titlePlan: "ご契約プラン",
    titlePayment: "お支払い登録内容",
    titleDetails: "ご契約",
    headerBilling: "ご契約内容について",
    subheaderPlan: "ご利用可能数量",
    subheaderPayment: "カード情報",
    detailPadlock: "スマートロック台数",
    detailUsers: "メンバー数",
    detailNFC: "NFC登録数",
    detailApproval: "承認アカウント数",
    detailCardNumber: "カード番号",
    detailCardExpiry: "有効期限",
    renewDescription: "ご契約プラン更新日 ",
    trialEndDescription1: "トライアルは",
    trialEndDescription2: "",
    trialEndDescription3: "",
    trialEndDescription4: "までです。",
    trialNotice:
      "トライアル終了後もシステムをご利用いただくには、有料プランへのアップグレードをお願いいたします。",
    trialWebOnlyNote:
      "これはWebダッシュボードにのみ影響します。トライアル終了後もeGeeTouchモバイルアプリは引き続きご利用いただけます。",
    planTypeMonth: "/月",
    planTypeYear: "/年",
  },
  es: {
    cancelPlanButton: "Cancelar Plan",
    changePlanButton: "Cambiar Plan",
    changePaymentButton: "Cambiar Método de Pago",
    tableHeaderMax: "Límite Máximo",
    tableHeaderCurrent: "Actual",
    titlePlan: "Plan Actual",
    titlePayment: "Método de Pago",
    titleDetails: "Detalles del Plan",
    headerBilling: "Facturación",
    subheaderPlan: "Agregar/Gestionar hasta",
    subheaderPayment: "Información de la Tarjeta",
    detailPadlock: "Candados Inteligentes",
    detailUsers: "Cuentas de Usuario",
    detailNFC: "Recuento de NFC",
    detailApproval: "Capa de Aprobación Múltiple",
    detailCardNumber: "Número de Tarjeta",
    detailCardExpiry: "Fecha de Expiración",
    renewDescription: "Tu plan se renueva el ",
    trialEndDescription1: "Tu ",
    trialEndDescription2: "prueba termina",
    trialEndDescription3: " el ",
    trialEndDescription4: "",
    trialNotice:
      "Para continuar utilizando el sistema después de que finalice tu prueba, por favor actualiza a un plan de pago.",
    trialWebOnlyNote:
      "Esto solo afecta al panel web — la aplicación móvil de eGeeTouch seguirá funcionando con normalidad después de que finalice tu prueba.",
    planTypeMonth: "/mes",
    planTypeYear: "/año",
  },
});


export class SubscriptionManagement extends Component {
  constructor(props) {
    super(props);

    this.cancelPlan = this.cancelPlan.bind(this);
    this.updateDetails = this.updateDetails.bind(this);

    this.state = {
      expDate: "",
      cardLast4: "",
      price: "",
      planName: "",
      planNumber: "",
      stripeSubscriptionId: "",
      open: false,
      currentLanguage: "",
      userAccounts: 0,
      userLocks: 0,
    };
  }
  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      //get total amount of accounts under the User.
      fire
        .database()
        .ref("groupAccounts/" + auth.currentUser.uid)
        .child("members")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let count = 0;
            snapshot.forEach((member) => {
              count++;
            });
            this.setState({
              userAccounts: count,
            });
          }
        });

      //get total amount of locks under the User.
      fire
        .database()
        .ref("userLocks/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let count = 0;
            snapshot.forEach((lock) => {
              count++;
            });
            this.setState({
              userLocks: count,
            });
          }
        });

      fire
        .database()
        .ref("groupAccounts/" + auth.currentUser.uid + "/payment")
        .once("value")
        .then(async (snapshot) => {
          if (snapshot.exists()) {
            const paymentDetails = snapshot.val();
            let cardExp = paymentDetails.cardExp;

            customLog(
              egeeTouchPlans["egeeTouchplan" + paymentDetails.plan].planPrice
            );

            this.setState({
              // price: egeeTouchPlans[egeeTouchplan + paymentDetails.plan].planPrice,
              price:
                paymentDetails.planType == "ANNUAL"
                  ? egeeTouchPlans["egeeTouchplan" + paymentDetails.plan]
                      .planPriceAnnual
                  : egeeTouchPlans["egeeTouchplan" + paymentDetails.plan]
                      .planPrice,
              planName:
                egeeTouchPlans["egeeTouchplan" + paymentDetails.plan].planName,
              planType: paymentDetails.planType,
              planNumber: paymentDetails.plan,
              specialTrialMode: paymentDetails.specialTrialMode,
              maxLocks: paymentDetails.maxLocks,
              maxUsers: paymentDetails.maxUsers,
              maxTags: paymentDetails.maxTags,
              maxMulti: paymentDetails.maxMulti,
              customPlanEndDate: paymentDetails.customPlanEndDate,
            });

            if (paymentDetails.specialTrialMode) {
              this.setState({
                trialEndDate: paymentDetails.trialEndDate * 1000,
              });
            }

            if (paymentDetails.plan === 4) {
              this.setState({
                endDate: paymentDetails.customPlanEndDate * 1000,
              });
            }

            const cardSplit = cardExp.split("/");
            if (cardSplit[0] < 10) {
              cardExp = `0${cardSplit[0]}/${cardSplit[1]}`;
            }

            const dataToGet = {
              subId: paymentDetails.stripeSubscriptionId,
            };

            let subDetailsURL = "";

            if (deploymentEnvironment) {
              subDetailsURL =
                "https://us-central1-egeetouchindustrial.cloudfunctions.net/getLiveSubscriptionDetails";
            } else {
              subDetailsURL =
                "https://us-central1-egeetouchindustrial.cloudfunctions.net/getTestSubscriptionDetails";
            }

            let getDetails = await fetch(subDetailsURL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToGet),
            });

            let returnedVal = await getDetails.json();

            customLog(returnedVal);

            //BELOW VALUES ARE RETRIVED FROM STRIPE API

            const formattedEndDate =
              returnedVal.current_period_end != null &&
              returnedVal.current_period_end != undefined
                ? returnedVal.current_period_end * 1000
                : 0;

            const formattedEndDateCustom =
              returnedVal.current_period_end != null &&
              returnedVal.current_period_end != undefined
                ? (returnedVal.current_period_end - 86400) * 1000
                : 0;

            const priceAmountDeci = returnedVal.items.data[0].plan.amount; //price

            const paymentType = returnedVal.items.data[0].plan.interval; // month / year

            const currencyType = returnedVal.currency; // currency type usd,eur,jpy

            //return will stop the function
            var symbol;
            if (currencyType === "usd") {
              symbol = "$";
            } else if (currencyType === "eur") {
              symbol = "£";
            } else {
              symbol = "¥";
            }

            //  console.log(`Amount : ${dataItem/100} paymentType: ${paymentType} curr: ${currencyType} `)

            // const formattedStartDate = timestampToDate(
            //   returnedVal.current_period_start,
            //   "DMTY"
            // );

            this.setState({
              // startDate: formattedStartDate,
              // startDate: `${startDateDay} ${startDateMonth} ${startDateYear}`,
              planType: paymentType === "year" ? "ANNUAL" : "MONTHLY",
              price: symbol + priceAmountDeci / 100,
              expDate: cardExp,
              cardLast4: paymentDetails.cardLastFourDigit,
              endDate:
                this.state.planName != "1-Year Custom"
                  ? formattedEndDate
                  : formattedEndDateCustom,
              // endDate: `${planEndDate} ${planEndMonth} ${planEndYear}`,
              stripeSubscriptionId: paymentDetails.stripeSubscriptionId,
            });

            this.setState({
              maxLocks: paymentDetails.maxLocks,
              maxUsers: paymentDetails.maxUsers,
              maxTags: paymentDetails.maxTags,
              maxMulti: paymentDetails.maxMulti,
            });
          }
        })
        .catch((err) => customLog(err));
    }
  }

  cancelPlan() {
    customLog("Hey cancelling the plan");
    const delTitle = "We're sad to see you go !";
    const delMessage = "Confirm cancellation of subscription ?";
    const delButton = [
      {
        label: "Confirm",
        onClick: () => {
          this.setState({ loading: true });
          const details = {
            subId: this.state.stripeSubscriptionId,
            uid: auth.currentUser.uid,
            language: this.state.currentLanguage,
          };

          cancelSub(details, (response) => {
            // customLog("Cancel response");
            customLog(response);
            if (response.ok) {
              const delConfirmTitle = "Subscription cancelled";
              const delConfirmMessage =
                "Your subscription has been cancelled successfully !";
              const delConfirmButton = [
                {
                  label: "Close",
                  onClick: () => {
                    window.location.href = "/plans";
                    return false;
                  },
                },
              ];

              //"Subscription Cancelled"
              showConfirmAlert(
                delConfirmTitle,
                delConfirmMessage,
                delConfirmButton
              );
            } // end of if(response !== ok)
          }); // end of cancelSub()
        }, //onClick
      },
      {
        label: "Cancel",
        onClick: () => {
          return false;
        },
      },
    ]; //delButton

    //"Sad to let you go"
    showConfirmAlert(delTitle, delMessage, delButton);
  }

  getPlanExpiry() {
    if (this.state.specialTrialMode) {
      return (
        <span style={{ fontWeight: "bold" }}>
          {localizationStrings.trialEndDescription1}
          <span style={{ fontWeight: "bolder" }}>
            {localizationStrings.trialEndDescription2}
          </span>
          {localizationStrings.trialEndDescription3}
          <span style={{ fontWeight: "bolder" }}>
            {this.dateFormat(this.state.trialEndDate)}
          </span>
          {localizationStrings.trialEndDescription4}
        </span>
      );
    } else {
      return (
        <span style={{ fontWeight: "bold" }}>
          {localizationStrings.renewDescription +
            this.dateFormat(this.state.endDate)}
        </span>
      );
    }
  }

  updateDetails(data) {
    this.setState({
      expDate: data.cardExp,
      cardLast4: data.cardLastFour,
    });
  }

  dateFormat(timeStamp) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(timeStamp);
      customLog(japanDate);
      customLog(timeStamp);
      return japanDate;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      // return <TimeStamp time={time/1000} format="full" includeDay />;
      return timestampToDate(timeStamp / 1000, "DMTY");
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    customLog(
      deploymentEnvironment
        ? "Live Environment @ Subscription Management"
        : "Test Environment @ Subscription Management"
    );
    let columnStyle = {
      width: "150px",
    };
    let columnDetailStyle = {
      width: "50px",
    };
    let columnCardStyle = {
      width: "100px",
    };

    return (
      <Elements stripe={stripePromise}>
        <div>
          <div
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingBottom: "5px",
              borderBottom: "1px solid #808080",
            }}
          >
            <h4>{localizationStrings.headerBilling}</h4>
            <br />
            <h5 style={{ marginBottom: "0px", marginTop: "0px" }}>
              {localizationStrings.titlePlan}
            </h5>
          </div>
          <div>
            <div style={{ paddingLeft: "40px" }}>
              {/* <div className={"alignCenter"}> */}
              <br />
              <h3 style={{ marginBottom: "5px", color: "#369AF6" }}>
                eGeeTouch {this.state.planName} plan
              </h3>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  display: this.state.price === undefined ? "none" : "",
                }}
              >
                {this.state.price}
                {this.state.planType === "ANNUAL"
                  ? localizationStrings.planTypeYear
                  : localizationStrings.planTypeMonth}
              </span>
              <div style={{ height: "10px" }}></div>
              {this.getPlanExpiry()}
              <br />
              <span style={{ fontWeight: "bold", color: "red" }}>
                {this.state.specialTrialMode
                  ? localizationStrings.trialNotice
                  : ""}
              </span>
              <br />
              <span style={{ fontStyle: "italic" }}>
                {this.state.specialTrialMode
                  ? localizationStrings.trialWebOnlyNote
                  : ""}
              </span>
              <br />
              <br />
              <h5 style={{ textDecoration: "underline", marginBottom: "0px" }}>
                {localizationStrings.titleDetails}
              </h5>
              <div style={{ height: "10px" }}></div>
              <span
                style={{
                  marginTop: "0px",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                {localizationStrings.subheaderPlan}
              </span>
              <div style={{ height: "10px" }}></div>
              <table className={"resManagementTable"}>
                <tr>
                  <th style={columnStyle}></th>
                  <th style={columnDetailStyle}>
                    <span
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      {localizationStrings.tableHeaderMax}
                    </span>
                  </th>
                  {/* <th style={columnDetailStyle}><span style={{ textDecoration: "underline", fontWeight: "bold"  }}>{localizationStrings.tableHeaderCurrent}</span></th> */}
                </tr>
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailPadlock}
                  </td>
                  <td style={columnDetailStyle}>{this.state.maxLocks}</td>
                  {/* <td style={columnDetailStyle}>{"/ " + this.state.userLocks}</td> */}
                </tr>
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailUsers}
                  </td>
                  <td style={columnDetailStyle}>{this.state.maxUsers}</td>
                  {/* <td style={columnDetailStyle}>{"/ " + this.state.userAccounts}</td> */}
                </tr>
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailNFC}
                  </td>
                  <td style={columnDetailStyle}>{this.state.maxTags}</td>
                  {/* <td style={columnDetailStyle}>{"/ " + this.state.userAccounts}</td> */}
                </tr>
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailApproval}
                  </td>
                  <td style={columnDetailStyle}>{this.state.maxMulti}</td>
                </tr>
              </table>
              <br />
              <div
                className={"ManagementFlexbox"}
                style={{
                  display: this.state.specialTrialMode ? "none" : "flex",
                }}
              >
                <Nav className={"resManagementNav"}>
                  <LinkContainer
                    id="ahrefToPlans"
                    to="/plans"
                    className={"changePlanBtn"}
                  >
                    <button>{localizationStrings.changePlanButton}</button>
                  </LinkContainer>
                  <div className={"spacingManagement"}></div>
                  <button className={"cancelSubBtn"} onClick={this.cancelPlan}>
                    {localizationStrings.cancelPlanButton}
                  </button>
                </Nav>
              </div>
            </div>
          </div>
          <br />
          <br />
          {this.state.planNumber !== 21 && this.state.planNumber !== 4 && (
            <div>
              <div
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  paddingBottom: "5px",
                  borderBottom: "1px solid #808080",
                }}
              >
                <h5 style={{ fontWeight: "bold", marginBottom: "0px" }}>
                  {localizationStrings.titlePayment}
                </h5>
              </div>
              <div style={{ paddingLeft: "40px" }}>
                <h4 style={{ marginBottom: "0px" }}>
                  {localizationStrings.subheaderPayment}
                </h4>
                <table
                  style={{ marginTop: "0px" }}
                  className={"resManagementTable"}
                >
                  <tr>
                    <td style={columnStyle} className={"resManagementTD"}>
                      {localizationStrings.detailCardNumber}
                    </td>
                    <td style={columnCardStyle}>
                      {this.state.specialTrialMode
                        ? "-"
                        : "•••• •••• •••• " + this.state.cardLast4}
                    </td>
                  </tr>
                  <tr>
                    <td style={columnStyle} className={"resManagementTD"}>
                      {localizationStrings.detailCardExpiry}
                    </td>
                    <td style={columnCardStyle}>
                      {this.state.specialTrialMode ? "-" : this.state.expDate}
                    </td>
                  </tr>
                </table>
                <br />
                <ChangeCardElement dataCallBack={this.updateDetails} />
              </div>
            </div>
          )}
        </div>
      </Elements>
    );
  }
}

export default SubscriptionManagement;
